module.exports = function() { return __webpack_public_path__ + "IPM-calendar-icon.1-rN3oH0EuhSkq_Lh1Ob.png";};